<script>
    let username = '';
    let password = '';
    let isLoading = false;
    let isSuccess = false;

    export let submit;

    /**
     * A message explaining why the login form is being shown, such as the session having
     * expired. Cleared once the user starts logging in again.
     */
    export let message = null;

    let errors = {};

    const handleSubmit = () => {
        errors = {};
        message = null;
        if (username.length === 0) {
            errors.username = 'Användarnamn saknas';
        }

        if (password.length === 0) {
            errors.password = 'Lösenord saknas';
        }

        if (Object.keys(errors).length === 0) {
            isLoading = true;
            submit({ username: username, password: password })
                .then(() => {
                    isSuccess = true;
                    isLoading = false;
                })
                .catch((err) => {
                    errors.server = err;
                    isLoading = false;
                });
        }
    };
</script>

<form on:submit|preventDefault={handleSubmit}>
    {#if isSuccess}
        <div class="success">
            🔓
            <br />
            Du är inloggad
        </div>
    {:else}
        <img
            class="logo"
            srcset="/assets/logo-100.png 1x, /assets/logo-200.png 2x"
            src="/assets/logo-200.png"
            width="85"
            height="100"
            alt="Logga - Ett stiliserat barn som gungar på en gunga"
        />

        {#if message}
            <div class="alert alert-info message" role="alert">{message}</div>
        {/if}

        <label for="username">Användarnamn</label>
        <!-- svelte-ignore a11y-autofocus -->
        <input name="username" bind:value={username} autocomplete="username" autofocus />

        <label for="password">Lösenord</label>
        <input name="password" type="password" autocomplete="current-password" bind:value={password} />

        <button type="submit">
            {#if isLoading}Loggar in ...{:else}Logga in{/if}
        </button>

        {#if Object.keys(errors).length > 0}
            <ul class="errors">
                {#each Object.keys(errors) as field}
                    <li>{errors[field]}</li>
                {/each}
            </ul>
        {/if}
    {/if}
</form>

<style>
    /* No fixed height: the form is taller than 400px even empty, and the session message
       and the error list each add to it, so a fixed height left the password field, the
       button and the errors hanging outside the white box. Narrow screens get the full
       width, with the padding easing off so the fields keep their room. */
    form {
        background: white;
        padding: clamp(24px, 8vw, 50px);
        width: 100%;
        max-width: 300px;
        margin: auto;
        text-align: center;
    }
    label {
        margin: 10px 0;
        text-align: left;
        font-weight: 500;
    }
    input {
        border: none;
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
        width: 100%;
    }
    input:focus {
        outline: 0;
        border-bottom: 1px solid #666;
    }
    button {
        margin-top: 20px;
        background: black;
        color: white;
        padding: 10px 0;
        width: 100%;
        border-radius: 25px;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
    }
    button:hover {
        background: #333;
    }
    button:active {
        background: black;
        color: #ddd;
    }
    .logo {
        margin: 0 auto 40px auto;
    }
    /* A little more air than the Bootstrap default, to match the spacing of the logo */
    .message {
        margin-bottom: 30px;
    }
    .errors {
        list-style-type: none;
        padding: 10px;
        margin: 0;
        border: 2px solid #be6283;
        color: #be6283;
        background: rgba(190, 98, 131, 0.3);
    }
    .success {
        font-size: 24px;
        text-align: center;
    }
</style>
